/* @sravni/react-design-system version 0.2.71 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { COLORS } from '../../../constants/colors.js';
import { CONTAINER_SIZES } from '../../../constants/sizes.js';
import '../../Spinner/index.js';
import modules_5118e2df from '../styles/Button.module.less.js';
import { Spinner } from '../../Spinner/src/Spinner.js';

/**
 * @description A Button triggers an action or an event
 *
 * @component
 * @example
 * ```jsx
 * <Button variant="primary" color="green" disabled block>
 *   Primary <Icon size="s" icon={<MenuIcon />} />
 * </Button>
 * ```
 */
var Button = React.forwardRef(function (props, ref) {
    var _a;
    var variant = props.variant, color = props.color, size = props.size, block = props.block, loading = props.loading, disabled = props.disabled, active = props.active, className = props.className, children = props.children, restProps = __rest(props, ["variant", "color", "size", "block", "loading", "disabled", "active", "className", "children"]);
    var cx = useStyles(modules_5118e2df);
    var classNames = cx(className, 'container', (_a = {
            block: block,
            loading: loading,
            active: active
        },
        _a["size-".concat(size)] = size,
        _a["disabled-".concat(variant)] = disabled || loading,
        _a["color-".concat(color, "-").concat(variant)] = true,
        _a));
    var textClassNames = cx('text');
    return (React.createElement("button", __assign({ "data-qa": "Button", ref: ref, className: classNames, disabled: disabled || loading }, restProps),
        React.createElement("span", { className: textClassNames }, children),
        loading && React.createElement(Spinner, { className: cx('spinner') })));
});
Button.defaultProps = {
    variant: 'outlined',
    color: COLORS.GRAY,
    size: CONTAINER_SIZES.S44,
};
Button.displayName = 'Button';

export { Button };
//# sourceMappingURL=Button.js.map
